"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = (theme) => ({
    root: {
        height: '100%',
    },
    link: {
        color: theme.palette.link,
        textDecoration: 'none',
        '& :hover': {
            textDecoration: 'none',
        },
    },
});
exports.default = styles;
